import React, { useState } from 'react';
import classnames from 'classnames';

import Icon from '~/core/scripts/components/Icon';
import useCsvData from '~/core/scripts/hooks/useCsvData';
import { isNumeric, shuffle, trackEvent } from '~/core/scripts/utils';
import CarCard from './CarCard';

import { startBrands } from '../config';

const convertNumbers = row => {
  Object.keys(row).forEach(columnName => {
    if (isNumeric(+row[columnName])) {
      row[columnName] = +row[columnName];
    }

    if (row[columnName] === 'NA') {
      row[columnName] = null;
    }
  });

  return row;
};

const isCorrectAnswer = (data, answerType) => {
  const isBelowAvg = data.CO2_Durchschnitt < c02avg;
  const isBelowTarget = data.CO2_Durchschnitt < c02target;

  switch (answerType) {
    case 'above':
      return !isBelowAvg;
    case 'below':
      return isBelowAvg;
    case 'below+':
      return isBelowTarget;
  }
};

const initialBrands = [...startBrands[~~(Math.random() * startBrands.length)]];
const c02avg = 160;
const c02target = 95;

function getSharingSentence(answers) {
  const correctAnswers = answers.filter(a => a).length;
  const answersCount = answers.length;

  return `Welche Automarke stößt das meiste CO₂ aus? Beim Auto-Quartett - in der "Klima-Edition" - habe ich ${correctAnswers} von ${answers.length} Frage${answersCount > 1 ? 'n' : ''} richtig beantwortet.`;
}

function getTwitterSentence(answers) {
  return getSharingSentence(answers) + ` ${ARTICLE_CONFIG.meta.ogUrl}`;
}

function getFacebookSentence(answers) {
  return getSharingSentence(answers) + '';
}

export default () => {
  const [visibleBrands, setVisibleBrands] = useState(initialBrands);
  const [answers, setAnswers] = useState([]);
  const data = useCsvData('daten_quartett.csv', ',', convertNumbers);

  if (!data) {
    return null;
  }

  const cards = visibleBrands.map(brand => data.find(d => d.Marke === brand));
  const hasNextCard = cards.length < data.length;
  const hasAnswers = answers.length > 0;
  const nextBrands = [...new Set(data.map(d => d.Marke).filter(brand => !visibleBrands.includes(brand)))];
  const options = nextBrands.map(brand => ({ name: brand, value: brand }));
  const cardsClasses = classnames('cards', { 'is-start': !hasAnswers });

  const onAddBrand = (brand, answerType) => {
    const isCorrect = isCorrectAnswer(
      data.find(d => d.Marke === brand),
      answerType
    );

    setAnswers(as => [...as, isCorrect]);

    const nextBrands = [...new Set(data.map(d => d.Marke).filter(brand => !visibleBrands.includes(brand)))];
    if (nextBrands.length) {
      const nextBrand = nextBrands[~~(Math.random() * nextBrands.length)];
      setVisibleBrands(vbs => [...vbs, nextBrand]);
    }
  };

  const onSelect = option => {
    setVisibleBrands(vbs => [...vbs.slice(0, vbs.length - 1), option.value]);
  };

  const onFbShare = () => {
    trackEvent('share', 1, 'class_C');

    FB.ui(
      {
        method: 'share',
        href: ARTICLE_CONFIG.meta.ogUrl,
        quote: getFacebookSentence(answers)
      },
      resp => {
        console.log(resp);
      }
    );
  };

  return (
    <div className="cards__wrapper">
      <div className={cardsClasses}>
        {cards.map((c, i) => (
          <CarCard
            {...c}
            index={i}
            key={`carcard__${c.Marke}`}
            isUncovered={i < cards.length - 1 || !hasNextCard}
            onAddBrand={onAddBrand}
            options={options}
            shuffledOptions={shuffle(options)}
            onSelect={onSelect}
          />
        ))}
      </div>
      {hasAnswers && (
        <div className="cards__footer">
          <div className="cards__footer-answers">
            <Icon type="star" />
            <div className="stats">
              <div className="stats-done">
                <strong>
                  {answers.filter(a => a).length} von {answers.length}
                </strong>{' '}
                richtig geschätzt
              </div>
              {hasNextCard && (
                <div className="stats-open">
                  Noch <strong>{data.length - cards.length}</strong> Karten zum Aufdecken
                </div>
              )}
            </div>
            <div className="social">
              <span className="social-tw">
              <a
                target="_blank"
                href={`https://twitter.com/intent/tweet?source=${encodeURIComponent(
                  ARTICLE_CONFIG.meta.ogUrl
                )}&text=${encodeURIComponent(getTwitterSentence(answers))}`}
              >
                <Icon type="twitter" />
              </a></span>
              <span className="social-fb">
              <Icon type="facebook" onClick={onFbShare} />
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
